import cookie from 'js-cookie'
import * as Lockr from 'lockr'

export const INVITATION_ID = 'invitationID'
export const TOKEN = 'token'
export const REFRESH_TOKEN = 'refresh_token'
export const MEMBER_ID = 'memberId'

const cookieList = [TOKEN, REFRESH_TOKEN, MEMBER_ID, 'userRm', 'isSubscribed']
const lockrList = [
  REFRESH_TOKEN,
  TOKEN,
  'rmMemberName',
  'selectedTab',
  'selectedTabProfile',
  'brokerName',
  'selectedTabInvestments',
  'zerodhaAccessToken',
  'portfolioFundFilters',
  'ohlcvData',
  'familyViewInvestmentsTab',
  'selectedTabPortfolioMutualFunds',
  'stockDetailsTab',
  'exploreStockDetailsTab',
  'selectedTabProposal',
  'clientFamilyId',
  'epfData',
  'platform',
  MEMBER_ID,
  'user_id',
]

export function clearCookies() {
  return cookieList.map(item => cookie.remove(item))
}

export function clearLocalStorage() {
  return lockrList.map(item => Lockr.rm(item))
}
